import React from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import { createLabelHelper } from 'infrastructure/js/utils/labelHelper';
import {reduxForm} from 'redux-form';
import Dialog from 'infrastructure/js/components/Dialog/dialog';
import * as dialogHelper from 'infrastructure/js/components/Dialog/dialogHelper';
import Grid from 'infrastructure/js/components/Grid/gridWrapper';
import {gridsNames} from '../../../../../../enums/gridsNames';
import {filterTypes} from 'infrastructure/js/enums/filterTypes';
import LabelWithTooltipCell from '../../../../../Common/CustomGridCells/LabelWithTooltipCell/labelWithTooltipCell';

require('./updateMaterialQplVersionDialog.scss');

class UpdateMaterialQplVersionDialog extends React.PureComponent {

  constructor(props) {
    super(props);

    this.dialogLabels = createLabelHelper('mat.dialog.');
    this.gridLabels = createLabelHelper('mat.administration.matsettings.dialog.updateMaterialQplVersion.grid.');
    this.labels = createLabelHelper('mat.administration.matsettings.dialog.updateMaterialQplVersion.');
    this.columnsConfig = this.createColumnsConfig();
  }

  createColumnsConfig = () => {
    let columnsConfig =  [
      {
        fieldName: 'businessId',
        title: this.gridLabels.get('columns.materialCode.title'),
        filterType: filterTypes.NONE,
        columnOptions: {
          sortable: false,
          cellComponent: LabelWithTooltipCell,
        },
      },
      {
        fieldName: 'name',
        title: this.gridLabels.get('columns.materialName.title'),
        filterType: filterTypes.NONE,
        columnOptions: {
          sortable: false,
          cellComponent: LabelWithTooltipCell,
        },
      },
    ]
    return columnsConfig;
  }

  getDialogButtons() {
    let selectedRowsData = this.props.sGrid?.get('selectedRowsData') ?? List();

    return {
      left: [
        {
          id:'cancel',
          text: this.dialogLabels.get('cancel'),
          action: this.props.actions.hide
        }
      ],
      right: [
        {
          id:'submit',
          text: this.dialogLabels.get('update'),
          bsStyle: 'primary',
          loading: this.props.sData.get('loading'),
          action: this.props.handleSubmit(this.onSubmit),
          disabled: (!selectedRowsData?.size ||
                    this.props.sData.get('loading') ||
                    this.props.sData.get('hasError') ||
                    ( this.props.sData.get('showIgnoreValidationCheckbox') &&
                      !this.props.sData.get('isIgnoreValidationWarnings') )
          )
        }
      ]
    };
  }

  onSubmit = () => {
    let selectedMaterials = this.props.sGrid?.get('selectedRowsData')?.toJS() ?? [];

    const data = {
      materialsIds: selectedMaterials.map(item => item.id),
      activeQplId : this.props.sData?.get('qplId')
    }
    this.props.actions.submit(data);
  };

  onHide =() => {
    this.props.actions.hide();
  };

  getFooterValidationCheckBox = () => {
    return this.props.sData.get('showIgnoreValidationCheckbox') ?
      {label: this.dialogLabels.get('ignorewarnings'),onChange: this.onFooterValidationChange} : null;
  };

  onFooterValidationChange = (value) => {
    this.props.actions.toggleIgnoreValidationWarningsCheckbox(value);
  };

  render() {
    return (
      <Dialog
        id="update-material-qpl-version-dialog"
        className="update-material-qpl-version-dialog"
        titleText={this.labels.get('header.title')}
        show={this.props.sData.get('show')}
        onEntered={this.onEntered}
        onHide={this.onHide}
        sData={this.props.sData}
        footerValidationCheckbox={this.getFooterValidationCheckBox()}
        footerInformationIcon={dialogHelper.getFooterInformationIcon(this.props.sData, this.dialogLabels)}
        footerButtons={this.getDialogButtons()}
        onEnterKeyPress={this.props.handleSubmit(this.onSubmit)}
      >

        <label>{this.labels.get('top.title')}</label>


        <Grid gridName={gridsNames.ADMINISTRATION_MAT_SETTINGS_UPDATE_MATERIAL_QPL_VERSION}
              className='select-work-orders-grid'
              columnsConfig={this.columnsConfig}
              rows={this.props.sData.get('items') ?? []}
              isStatic={true}
              gridProps={
                {
                  sideBar: false,
                }
              }
        >
        </Grid>
      </Dialog>
    );
  }
}

export default reduxForm({
    form: 'updateKitTypeVersionDialog',
    onChange: (values, dispatch, props, previousValues) => {
      dialogHelper.onFormChangeHandler(values, props, previousValues);
    },
  }
)(UpdateMaterialQplVersionDialog);

UpdateMaterialQplVersionDialog.propTypes = {
  actions: PropTypes.object.isRequired,
  sData: PropTypes.object.isRequired,
};


